import * as React from 'react';
import { useContext, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { AccountCircle, ExitToApp, Lock } from '@material-ui/icons';
import * as styles from './user-menu.module.scss';
import { AppContext, AppProviderDispatch } from '../../shared/app-context';
import MaterialIcon from '@material/react-material-icon';
import { useOktaAuth } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5'
  }
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [firstName, setFirstName] = React.useState(null);
  const [lastName, setLastName] = React.useState(null);
  const { state, setState } = useContext<AppProviderDispatch>(AppContext);
  const { oktaAuth } = useOktaAuth();
  const history = useHistory();

  useEffect(() => {
    if (state.firstName !== undefined && state.firstName !== null && state.firstName !== '') {
      setFirstName(state.firstName);
      setLastName(state.lastName);

      return;
    }

    oktaAuth.getUser().then(user => {
      localStorage.setItem('firstName', user.given_name);
      localStorage.setItem('lastName', user.family_name);
      localStorage.setItem('email', user.email);
      setFirstName(user.given_name);
      setLastName(user.family_name);
      setState({ firstName: user.given_name, lastName: user.family_name, email: user.email });
    });
  }, []);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleLogout() {
    oktaAuth.signOut().then(() => {
      setState({
        firstName: '',
        lastName: '',
        email: undefined,
        isAdmin: false,
        globalAnnouncement: '',
        clientAnnouncement: ''
      });
      localStorage.removeItem('firstName');
      localStorage.removeItem('lastName');
      localStorage.removeItem('email');
    });
  }

  function handleChangePassword() {
    history.push('/change-password');
  }

  return (
    <React.Fragment>
      <div className={styles.userMenu}>
        <Button aria-controls="customized-menu" aria-haspopup="true" onClick={handleClick}>
          <AccountCircle />
          {firstName} {lastName}
          <MaterialIcon className={styles.arrowDropDown} icon="arrow_drop_down" />
        </Button>
      </div>
      <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleChangePassword}>
          <ListItemIcon>
            <Lock />
          </ListItemIcon>
          <ListItemText primary="Change Password" />
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <ExitToApp />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </MenuItem>
      </StyledMenu>
    </React.Fragment>
  );
};
export default UserMenu;
